import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function MobileBottomCTA() {
  const [isVisible, setIsVisible] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > 600) {
        if (currentScrollY > lastScrollY) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      } else {
        setIsVisible(false);
      }
      setLastScrollY(currentScrollY);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);
  const handleApplyClick = () => {
    window.location.href = 'Application';
  };
  return <AnimatePresence data-id="element-407">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} className="fixed bottom-0 left-0 right-0 bg-black border-t border-zinc-800 p-4 z-30 md:hidden" data-id="element-408">
          <div className="flex items-center justify-between gap-4" data-id="element-409">
            <span className="text-sm font-medium text-white" data-id="element-410">Get Funded</span>
            <button onClick={handleApplyClick} className="flex-1 bg-white text-black font-medium py-3 rounded-lg flex items-center justify-center gap-2 text-sm hover:bg-gray-200 transition-colors" data-id="element-411">
              Apply Now
              <ArrowRightIcon className="w-4 h-4" data-id="element-412" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}